/**
 * Query parameters an authorization server can put on a redirect back to the app.
 */
export const MSAL_RESPONSE_PARAMS = [
  'state', 'code', 'error', 'error_description', 'error_uri', 'session_state',
  'client_info', 'id_token', 'access_token', 'token_type', 'expires_in', 'scope', 'clientdata',
]

/**
 * Remove auth response parameters from the query string of `href`, leaving application
 * parameters and the fragment untouched.
 *
 * msal-browser v5 treats any url carrying a `state` parameter as an auth response, and it reads
 * the query string as well as the hash (v4 only read the hash). Its own post-response cleanup
 * still only clears the hash, so the `?state=...` Entra appends to `postLogoutRedirectUri`
 * survives in the address bar. Signing in from that url makes it the `navigateToLoginRequestUrl`
 * target, MSAL returns there after redeeming the code, re-reads the stale state and throws
 * `state_mismatch` — which the app surfaces as "logged out" right after a successful login.
 */
export function stripMsalResponseParams (href: string): string {
  const url = new URL(href)
  const removed = MSAL_RESPONSE_PARAMS.filter(param => url.searchParams.has(param))
  if (removed.length === 0) return href

  removed.forEach(param => url.searchParams.delete(param))
  return url.toString()
}
